import {
  initialInvoiceIncomingEditForm,
  initialInvoiceIncomingItemEditForm,
} from "services/api/finance/incoming-invoices/consts";
import {
  InvoiceIncomingEditFormValues,
  InvoiceIncomingExtraction,
} from "services/api/finance/incoming-invoices/types";

/**
 * Podatke pročitane s računa prevodi u vrijednosti obrasca. Sve ostaje uređivo — pročitano je
 * prijedlog, a korisnik potvrđuje. Datoteka se pamti u `uploadIds` da ostane priložena računu.
 */
export const buildFormValuesFromExtraction = (
  extraction: InvoiceIncomingExtraction,
  uploadId: string,
  vehicleId: string | null
): InvoiceIncomingEditFormValues => ({
  ...initialInvoiceIncomingEditForm,
  vehicleId,
  contactSupplierId: extraction.contactSupplierId,
  supplierName: extraction.supplierName,
  supplierAddress: extraction.supplierAddress,
  supplierOIB: extraction.supplierOIB,
  supplierIBAN: extraction.supplierIBAN,
  invoiceNumber: extraction.invoiceNumber,
  invoiceDate: extraction.invoiceDate ?? new Date(),
  dueDate: extraction.dueDate,
  currencyId: extraction.currencyId ?? "EUR",
  totalWithoutTax: extraction.totalWithoutTax,
  totalTax: extraction.totalTax,
  total: extraction.total,
  expenseTypeId: extraction.expenseTypeId,
  statusId: "received",
  incomingSourceId: "upload",
  uploadIds: [uploadId],
  items: extraction.items.map(item => ({
    ...initialInvoiceIncomingItemEditForm,
    id: crypto.randomUUID(),
    code: item.code,
    name: item.name,
    quantity: item.quantity ?? 1,
    priceWithoutTax: item.priceWithoutTax,
    // Cijena s PDV-om se računa iz osnovice, kao i drugdje u obrascu stavki.
    priceWithTax: item.priceWithoutTax != null && item.taxRate != null
      ? Number((item.priceWithoutTax * (1 + item.taxRate / 100)).toFixed(2))
      : null,
    taxRate: item.taxRate ?? 25,
    discountTypeId: "PERCENTAGE",
    discountPercent: item.discountPercent,
    total: item.total,
  })),
});
